import { useEffect, useState } from 'react'

import { useResizeObserver } from './useResizeObserver'
import { arraySeq } from './utils'

interface MeasurementProps {
  element: React.RefObject<HTMLDivElement | null>
}

export function useMeasurement({ element }: MeasurementProps) {
  const [totalPages, setTotalPages] = useState(0)
  const [scrollOffset, setScrollOffset] = useState(arraySeq(totalPages, 0))
  const dimensions = useResizeObserver(element)

  useEffect(() => {
    const container = element.current
    if (!(container && dimensions)) return

    /**
     * determine the width of the content that is not visible (overflow)
     * we ignore the bounding box width because its a float
     * and scrollWidth is an integer, so it creates an imperfect
     * calculation when the scrollWidth is a few pixels larger
     */
    const scrollWidth = container.scrollWidth
    const visibleWidth = container.offsetWidth

    if (visibleWidth === 0) return

    const pageCount = Math.round(scrollWidth / visibleWidth)

    setTotalPages(pageCount)
    setScrollOffset(arraySeq(pageCount, visibleWidth))
  }, [element, dimensions])

  return { totalPages, scrollOffset }
}
